import Button from '@mui/material/Button';
import React from 'react';

type SubmitSpinningButtonProps = {
    error?: boolean
    text?: string
    showSpinner: boolean
    className?: string
    variant?: "text" | "outlined" | "contained"
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

function SubmitSpinningButton({ className, error, onClick, showSpinner, text, variant }: SubmitSpinningButtonProps) {
    let btnTheme = 'btn-outline-primary';
    if (className) {
        btnTheme = className
    }

    if (!text) {
        text = 'Submit'
    }

    let buttonText: string | JSX.Element = text;

    if (showSpinner) {
        buttonText = <img className="pull-right" src="/images/ajax-loader.gif" />
    }

    if (!variant) {
        variant = 'outlined';
    }

    let type: "button" | "submit" | "reset" = 'submit';
    if (onClick) {
        type = 'button'
    }

    if (error || className=="btn-outline-danger") {
        return (<Button onClick={onClick} variant={variant} disableElevation color="secondary" className="pull-right" type={type}>{buttonText}</Button>);
    }
    return (<Button onClick={onClick} color="primary" className="pull-right" type={type} variant={variant} disableElevation>{buttonText}</Button>);
}

export { 
    SubmitSpinningButton
}